import { Badge, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getSettingsItems, runSettingsItem } from "./settingsItems";

function SettingsMenu({
  devPort,
  anchorEl,
  setAnchorEl,
  managerMode,
  betaMode,
}) {
  let navigate = useNavigate();
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Menu
      id="menu-appbar"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      {getSettingsItems(managerMode, betaMode).map((item) =>
        item.isNew ? (
          <Badge
            key={item.key}
            badgeContent="New"
            color="success"
            style={{ right: 15, top: 8 }}
          >
            <MenuItem
              onClick={() => runSettingsItem(item.key, navigate, devPort)}
              style={{ right: -15, top: -8 }}
            >
              {item.label}
            </MenuItem>
          </Badge>
        ) : (
          <MenuItem
            key={item.key}
            onClick={() => runSettingsItem(item.key, navigate, devPort)}
          >
            {item.label}
          </MenuItem>
        )
      )}
    </Menu>
  );
}
export default SettingsMenu;
